/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 PRO React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 PRO React layouts
// import SignInBasic from "layouts/authentication/sign-in/basic";

// Material Dashboard 2 PRO React TS components
import MDAvatar from "components/MDAvatar";
import UserAvatar from "components/UserAvatar";

// @mui icons
import Icon from "@mui/material/Icon";

// Images
import profilePicture from "assets/images/team-3.jpg";

import SignInBasicScreen from "Screens/Authentication/sign-in/SignInBasicScreen/SignInBasicScreen";
import MediInStepAnalyticsDashboardScreen from "Screens/MediInStepDashboardScreen/MediInStepAnalyticsDashboardScreen/MediInStepAnalyticsDashboardScreen";

// User Profile
import MediInStepUserProfileScreen from "Screens/MediInStepUserProfileScreen/MediInStepUserProfileScreen";
import MediInStepUserSettingScreen from "Screens/MediInStepUserSettingScreen/MediInStepUserSettingScreen";

// Users
// import UserListScreen from "Screens/Users/UserListScreen"; // Use original screen
import MediInStepUserScreen from "Screens/MediInStepUserScreen/MediInStepUserScreen";
import UserDetailScreen from "Screens/Users/UserDetailScreen";
import LoginHistoryListScreen from "Screens/LoginHistory/LoginHistoryListScreen";
import DeviceInfoListScreen from "Screens/Devices/DeviceInfoListScreen";
import StepRecordListScreen from "Screens/StepRecords/StepRecordListScreen";
import PointBalanceListScreen from "Screens/PointBalance/PointBalanceListScreen";
import PointTransactionListScreen from "Screens/PointTransaction/PointTransactionListScreen";
import PointUseRequestListScreen from "Screens/PointUseRequest/PointUseRequestListScreen";
import AttendanceListScreen from "Screens/Attendance/AttendanceListScreen";

// Tenants
import TenantListScreen from "Screens/Tenants/TenantListScreen";
import TenantFormScreen from "Screens/Tenants/TenantFormScreen";

// Contents
import VideoListScreen from "Screens/Contents/VideoListScreen";
import VideoFormScreen from "Screens/Contents/VideoFormScreen";
import VideoStatsScreen from "Screens/Contents/VideoStatsScreen";
import VideoWatchHistoryScreen from "Screens/Contents/VideoWatchHistoryScreen";
import ExerciseVideoListScreen from "Screens/ExerciseVideos/ExerciseVideoListScreen";
import VideoSettingsScreen from "Screens/Contents/VideoSettingsScreen";


// Advertisements
import AdvertiserListScreen from "Screens/Advertisements/AdvertiserListScreen";
import AdvertiserFormScreen from "Screens/Advertisements/AdvertiserFormScreen";
import BannerListScreen from "Screens/Advertisements/BannerListScreen";
import InterstitialAdListScreen from "Screens/Advertisements/InterstitialAdListScreen";
import BannerFormScreen from "Screens/Advertisements/BannerFormScreen";
import AdClickLogListScreen from "Screens/Advertisements/AdClickLogListScreen";

import AdViewLogListScreen from "Screens/Advertisements/AdViewLogListScreen";

// Notifications
import TemplateListScreen from "Screens/Notifications/TemplateListScreen";
import PushCampaignListScreen from "Screens/Notifications/PushCampaignListScreen";
import PushCampaignCreateScreen from "Screens/Notifications/PushCampaignCreateScreen";
import PushHistoryScreen from "Screens/Notifications/PushHistoryScreen";

// Points
import PointPolicyListScreen from "Screens/Points/PointPolicyListScreen";
import PointLimitPolicyListScreen from "Screens/Points/PointLimitPolicyListScreen";

import PointUsePolicyListScreen from "Screens/PointUsePolicy/PointUsePolicyListScreen";
import UserBalanceScreen from "Screens/Points/UserBalanceScreen";
import TransactionHistoryScreen from "Screens/Points/TransactionHistoryScreen";
import UsageRequestScreen from "Screens/Points/UsageRequestScreen";

// SMS
import SmsSettingsScreen from "Screens/Sms/SmsSettingsScreen";
import SmsHistoryScreen from "Screens/Sms/SmsHistoryScreen";

// System
import AppVersionScreen from "Screens/System/AppVersionScreen";
import CompanySettingsScreen from "Screens/System/CompanySettingsScreen";
import CommonCodeListScreen from "Screens/CommonCode/CommonCodeListScreen";
import AdminActionLogScreen from "Screens/System/AdminActionLogScreen";
import SurgerySiteListScreen from "Screens/SurgerySites/SurgerySiteListScreen";
import BodyPartListScreen from "Screens/BodyParts/BodyPartListScreen";

// Gifticon
import GifticonSettingsScreen from "Screens/Gifticons/GifticonSettingsScreen";
import GifticonProductListScreen from "Screens/Gifticons/GifticonProductListScreen";
import GifticonRequestHistoryScreen from "Screens/Gifticons/GifticonRequestHistoryScreen";
import GifticonCategoryListScreen from "Screens/Gifticons/GifticonCategoryListScreen";

// Legal Terms
import LegalTermsListScreen from "Screens/LegalTerms/LegalTermsListScreen";
import UserAgreementStatusScreen from "Screens/LegalTerms/UserAgreementStatusScreen";

// FAQ
import FAQListScreen from "Screens/FAQ/FAQListScreen";
import CustomerSupportSettingsScreen from "Screens/CustomerSupport/CustomerSupportSettingsScreen";

// Inquiry
import InquiryListScreen from "Screens/Inquiry/InquiryListScreen";

// Analytics
import UserStatsScreen from "Screens/Analytics/UserStatsScreen";
import ActivityStatsScreen from "Screens/Analytics/ActivityStatsScreen";
import PointStatsScreen from "Screens/Analytics/PointStatsScreen";
import AdStatsScreen from "Screens/Analytics/AdStatsScreen";
import DashboardScreen from "Screens/Dashboard/DashboardScreen";

// Public Screens
import PublicTermScreen from "Screens/LegalTerms/PublicTermScreen";
import PublicInquiryScreen from "Screens/Inquiry/PublicInquiryScreen";

// Utils
import { isMasterUser } from "Shared/Utils/CredentialStorage";

const routes = () => {
  const userName = "사용자"; // 기본값, UserAvatar에서 실제 이름 로드
  // const isMaster = isMasterUser(); // Master 사용자 여부 확인
  const isMaster = true; // TODO: Remove this line to restore permission checks

  const allRoutes = [
    {
      type: "collapse",
      name: userName,
      key: "account",
      icon: <UserAvatar size="sm" />,
      collapse: [
        {
          name: "계정정보",
          key: "my-profile",
          route: "/account/my-profile",
          component: <MediInStepUserProfileScreen />,
        },
        {
          name: "로그아웃",
          key: "logout",
          route: "/authentication/sign-in/basic",
          component: <SignInBasicScreen />,
        },
      ],
    },
    { type: "divider", key: "divider-0" },
    {
      type: "collapse",
      name: "대시보드",
      key: "dashboards",
      icon: <Icon fontSize="medium">dashboard</Icon>,
      collapse: [
        {
          name: "통합 현황",
          key: "dashboard",
          route: "/dashboards/dashboard",
          component: <DashboardScreen />,
        },
      ],
    },
    // 테넌트 관리 - Master 사용자만 표시
    ...(isMaster ? [{
      type: "collapse",
      name: "테넌트 관리",
      key: "tenants",
      icon: <Icon fontSize="medium">domain</Icon>,
      collapse: [
        {
          name: "테넌트 목록",
          key: "list",
          route: "/tenants/list",
          component: <TenantListScreen />,
        },
      ],
    }] : []),
    { type: "title", title: "관리 메뉴", key: "title-management" },
    {
      type: "collapse",
      name: "회원 관리",
      key: "users",
      icon: <Icon fontSize="medium">people</Icon>,
      collapse: [
        {
          name: "회원 목록",
          key: "list",
          route: "/users/list",
          component: <MediInStepUserScreen />,
        },
        {
          name: "로그인 이력",
          key: "login-history",
          route: "/users/login-history",
          component: <LoginHistoryListScreen />,
        },
        {
          name: "디바이스 정보",
          key: "device-info",
          route: "/users/device-info",
          component: <DeviceInfoListScreen />,
        },
      ],
    },
    {
      type: "collapse",
      name: "출석 관리",
      key: "attendance",
      icon: <Icon fontSize="medium">calendar_today</Icon>,
      collapse: [
        {
          name: "목록",
          key: "list",
          route: "/attendance/list",
          component: <AttendanceListScreen />,
        },
      ],
    },
    // 수술부위 관리 - Master 사용자만 표시 (회원 관리 아래로 이동)
    ...(isMaster ? [{
      type: "collapse",
      name: "수술부위 관리",
      key: "surgery-sites",
      icon: <Icon fontSize="medium">healing</Icon>,
      route: "/surgery-sites/list",
      noCollapse: true,
      component: <SurgerySiteListScreen />,
    },
    {
      type: "collapse",
      name: "관심부위 관리",
      key: "body-parts",
      icon: <Icon fontSize="medium">accessibility_new</Icon>,
      collapse: [
        {
          name: "카테고리 관리",
          key: "categories",
          route: "/body-parts/categories",
          component: <CommonCodeListScreen fixedGroupCode="INTEREST_AREA_CATEGORY" />,
        },
        {
          name: "부위 목록",
          key: "list",
          route: "/body-parts/list",
          component: <BodyPartListScreen />,
        },
      ],
    }] : []),
    {
      type: "collapse",
      name: "걸음수기록",
      key: "step-records",
      icon: <Icon fontSize="medium">directions_walk</Icon>,
      collapse: [
        {
          name: "걸음수 조회",
          key: "step-list",
          route: "/step-records/list",
          component: <StepRecordListScreen />,
        },
      ],
    },
    {
      type: "collapse",
      name: "콘텐츠 관리",
      key: "contents",
      icon: <Icon fontSize="medium">video_library</Icon>,
      collapse: [
        {
          name: "재활 영상",
          key: "videos",
          collapse: [
            {
              name: "영상 목록",
              key: "list",
              route: "/contents/videos/list",
              component: <ExerciseVideoListScreen />,
            },
            {
              name: "영상 시청 이력",
              key: "watch-history",
              route: "/contents/watch-history",
              component: <VideoWatchHistoryScreen />,
            },
          ]
        },
        {
          name: "설정",
          key: "video-settings",
          route: "/contents/videos/settings",
          component: <VideoSettingsScreen />,
        },
      ],
    },
    {
      type: "collapse",
      name: "광고 관리",
      key: "advertisements",
      icon: <Icon fontSize="medium">campaign</Icon>,
      collapse: [
        {
          name: "광고주 관리",
          key: "advertisers",
          collapse: [
            {
              name: "광고주 목록",
              key: "list",
              route: "/advertisements/advertisers/list",
              component: <AdvertiserListScreen />,
            },
          ]
        },
        {
          name: "전면광고",
          key: "banners",
          collapse: [
            {
              name: "전면광고 목록",
              key: "list",
              route: "/advertisements/banners/list",
              component: <InterstitialAdListScreen />,
            },
            {
              name: "광고 성과통계",
              key: "stats",
              route: "/advertisements/banners/stats",
              component: <AdStatsScreen />,
            },

            {
              name: "광고 노출 기록",
              key: "view-log",
              route: "/advertisements/banners/view-log",
              component: <AdViewLogListScreen />,
            },
            {
              name: "광고 클릭 기록",
              key: "click-log",
              route: "/advertisements/banners/click-log",
              component: <AdClickLogListScreen />,
            },
          ]
        },
      ],
    },
    {
      type: "collapse",
      name: "기프티쇼 비즈",
      key: "gifticons",
      icon: <Icon fontSize="medium">card_giftcard</Icon>,
      collapse: [
        {
          name: "설정",
          key: "settings",
          route: "/gifticons/settings",
          component: <GifticonSettingsScreen />,
        },
        {
          name: "카테고리 관리",
          key: "categories",
          route: "/gifticons/categories",
          component: <GifticonCategoryListScreen />,
        },
        {
          name: "상품 관리",
          key: "products",
          route: "/gifticons/products",
          component: <GifticonProductListScreen />,
        },
        {
          name: "기프티쇼 거래내역",
          key: "requests",
          route: "/gifticons/requests",
          component: <GifticonRequestHistoryScreen />,
        },
      ],
    },
    {
      type: "collapse",
      name: "알림 관리",
      key: "notifications",
      icon: <Icon fontSize="medium">notifications</Icon>,
      collapse: [
        {
          name: "알림 템플릿",
          key: "templates",
          collapse: [
            {
              name: "템플릿 목록",
              key: "list",
              route: "/notifications/templates/list",
              component: <TemplateListScreen />,
            },
          ]
        },
        {
          name: "푸시 캠페인",
          key: "campaigns",
          collapse: [
            {
              name: "캠페인 목록",
              key: "list",
              route: "/notifications/campaigns/list",
              component: <PushCampaignListScreen />,
            },

            {
              name: "발송 이력",
              key: "history",
              route: "/notifications/history",
              component: <PushHistoryScreen />,
            },
          ]
        },
      ],
    },
    {
      type: "collapse",
      name: "포인트 관리",
      key: "points",
      icon: <Icon fontSize="medium">monetization_on</Icon>,
      collapse: [
        {
          name: "정책 관리",
          key: "policy",
          collapse: [
            {
              name: "포인트 적립 정책",
              key: "earning",
              route: "/points/policy/earning",
              component: <PointPolicyListScreen />,
            },

            {
              name: "포인트 적립 한도정책",
              key: "point-limit",
              route: "/points/policy/point-limit",
              component: <PointLimitPolicyListScreen />,
            },
            {
              name: "포인트 사용 정책",
              key: "use-policy",
              route: "/points/policy/use-policy",
              component: <PointUsePolicyListScreen />,
            },
          ]
        },
        {
          name: "사용자 잔액 조회",
          key: "user-balance",
          route: "/points/user-balance",
          component: <PointBalanceListScreen />,
        },
        {
          name: "거래 내역",
          key: "transactions",
          route: "/points/transactions",
          component: <PointTransactionListScreen />,
        },
        {
          name: "사용 요청 관리",
          key: "usage-requests",
          route: "/points/usage-requests",
          component: <PointUseRequestListScreen />,
        },
      ],
    },
    {
      type: "collapse",
      name: "SMS 관리",
      key: "sms",
      icon: <Icon fontSize="medium">sms</Icon>,
      collapse: [
        {
          name: "설정",
          key: "settings",
          route: "/sms/settings",
          component: <SmsSettingsScreen />,
        },
        {
          name: "발송 내역",
          key: "history",
          route: "/sms/history",
          component: <SmsHistoryScreen />,
        },
      ],
    },
    // 약관 관리 - Master 사용자만 접근 가능
    ...(isMaster
      ? [
        {
          type: "collapse" as const,
          name: "약관 관리",
          key: "legal-terms",
          icon: <Icon fontSize="medium">gavel</Icon>,
          collapse: [
            {
              name: "약관 목록",
              key: "terms-list",
              route: "/legal-terms/list",
              component: <LegalTermsListScreen />,
            },
            {
              name: "사용자 동의 현황",
              key: "agreement-status",
              route: "/legal-terms/agreement-status",
              component: <UserAgreementStatusScreen />,
            },
          ],
        },
      ]
      : []),
    // 고객지원 - Master 사용자만 접근 가능
    ...(isMaster
      ? [
        {
          type: "collapse" as const,
          name: "고객지원",
          key: "customer-support",
          icon: <Icon fontSize="medium">support_agent</Icon>,
          collapse: [
            {
              name: "1:1 문의",
              key: "inquiry-list",
              route: "/customer-support/inquiry/list",
              component: <InquiryListScreen />,
            },
            {
              name: "FAQ 관리",
              key: "faq-list",
              route: "/customer-support/faq/list",
              component: <FAQListScreen />,
            },
            {
              name: "설정",
              key: "settings",
              route: "/customer-support/settings",
              component: <CustomerSupportSettingsScreen />,
            },
          ],
        },
      ]
      : []),
    // 시스템 관리 - Master 사용자만 접근 가능
    ...(isMaster
      ? [
        {
          type: "collapse" as const,
          name: "시스템 관리",
          key: "system",
          icon: <Icon fontSize="medium">settings</Icon>,
          collapse: [
            {
              name: "앱 버전관리",
              key: "app-version",
              route: "/system/app-version",
              component: <AppVersionScreen />,
            },
            {
              name: "비즈니스 설정",
              key: "company-settings",
              route: "/system/company-settings",
              component: <CompanySettingsScreen />,
            },
            {
              name: "공통 코드 관리",
              key: "common-codes",
              route: "/system/common-codes",
              component: <CommonCodeListScreen />,
            },
            {
              name: "관리자 액션 로그",
              key: "action-logs",
              route: "/system/action-logs",
              component: <AdminActionLogScreen />,
            },
          ]
        },
      ]
      : []),

    // Public Routes (Accessible without login)

    {
      type: "public",
      name: "개인정보 처리방침",
      key: "public-privacy",
      route: "/public/terms/privacy",
      component: <PublicTermScreen initialType="privacy" />,
    },
    {
      type: "public",
      name: "서비스 이용약관",
      key: "public-service",
      route: "/public/terms/service",
      component: <PublicTermScreen initialType="service" />,
    },
    {
      type: "public",
      name: "마케팅 수신동의",
      key: "public-marketing",
      route: "/public/terms/marketing",
      component: <PublicTermScreen initialType="marketing" />,
    },
    // Specific Term by ID
    {
      type: "public",
      name: "약관 상세",
      key: "public-term-detail",
      route: "/public/terms/:id",
      component: <PublicTermScreen />,
    },
    // Public Inquiry (계정 삭제 요청)
    {
      type: "public",
      name: "문의 접수",
      key: "public-inquiry",
      route: "/public/inquiry",
      component: <PublicInquiryScreen />,
    },
  ];

  return allRoutes;
};

export default routes;
